import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Http, Response, URLSearchParams, Headers, RequestOptions } from '@angular/http';
import 'rxjs';

import { Subject, BehaviorSubject } from "rxjs";
import { HttpService } from "../shared/services/http.interceptor.service";
import { SlotDataService } from "./slots-data.service";

@Injectable()
export class SlotsService {
    public options: any;
    
    public currentLanguageSlots =  new BehaviorSubject<any>(null);
    setLanguage(lang){
        this.currentLanguageSlots.next(lang)
    }
    getLanguage(){
        return this.currentLanguageSlots.asObservable();
    }
    language = new Subject();
    constructor(private http: HttpService,
        public slotDataService: SlotDataService
    ) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.options = new RequestOptions({ headers: headers });
    }

    setAppFavicon(faviconUrl){
        // accessing favicon link tag
        let favIcon: HTMLLinkElement = document.querySelector('#appFavicon');

        let findUpdateIndex = faviconUrl.indexOf( "upload/");
        let findVersionIndex = faviconUrl.indexOf( "/v");
        if(findUpdateIndex != -1 && findVersionIndex != -1){
            let subArrfavUpload = faviconUrl.substring(0,(findUpdateIndex+7));
            let subArrfavVersion = faviconUrl.substring(findVersionIndex);
            faviconUrl = subArrfavUpload + "c_scale,w_32" + subArrfavVersion;
        }

        if(favIcon){
            favIcon.href = faviconUrl;
        }
    }
    
    /**
     * Function to get available appointments slots
     */
    getAppointmentSlots(page, appointmentCode,user,userTimeZone:string = "", isPublic: boolean = false): Observable<any> {
        var FetchLeadUserInfo = page==1 ? true : false;

        return this.http.get((isPublic ? 'publicflow/' : '')+'Appointment/GetAvailableBookingSlots?AppointmentCode=' + appointmentCode + '&PageIndex=' + page + '&FetchLeadUserInfo=' + FetchLeadUserInfo+ '&UserType='+ user+ '&UserTimeZoneId='+ userTimeZone,this.options)
            .map((response) => {
                var data = response.json().data;
                this.slotDataService.setAppointMentDetail(data);
                if(data && data.FavoriteIconUrl){
                    this.setAppFavicon(data.FavoriteIconUrl);
                } 
                return data;
            })
        
    }

    getTemplateBodyWithValueById(templateId,appointmentCode, isPublic: boolean = false): Observable<any> {
        return this.http.get((isPublic ? 'publicflow/' : '')+`NotificationTemplate/GetTemplateBodyWithValueById?notificationTemplateId=${templateId}&AppointmentCode=${appointmentCode}`)
            .map((response) => {
                return response.json().data;
            })
    }

    getTemplateBodyWithoutJT(templateId?): Observable<any> {
        return this.http.get('publicflow/NotificationTemplate/GetTemplateBodyWithoutJT?notificationTemplateId=' + templateId)
            .map((response) => {
                return response.json().data;
            })
    }
    /**
     * Function to book appointment
     * @param body : Body
     */
    bookAppointment(body, isPublic: boolean = false): Observable<any> {
        return this.http.post((isPublic ? 'publicflow/' : '')+'Appointment/ConfirmAppointmentBooking?', body,this.options)
            .map((response) => {
                return response.json().data;
            })
    }

    /**
     * Function to reschedule booked appointment
     * @param appointmentId : Reschedule appointment by appointmentId
     */
    rescheduleAppointment(page, appointmentCode,user,userTimeZone:string = "", isPublic: boolean = false): Observable<any> {
        var FetchLeadUserInfo = page == 1 ? true : false;
        return this.http.get((isPublic ? 'publicflow/' : '')+'Appointment/RescheduleBookedAppointment?AppointmentCode=' + appointmentCode + '&UserTimeZoneId=' + userTimeZone + '&PageIndex=' + page + '&FetchLeadUserInfo=' + FetchLeadUserInfo+ '&UserType='+ user,this.options)
            .map((response) => {
                var data = response.json().data;
                this.slotDataService.setAppointMentDetail(data);
                return data;
            })
    }

    rescheduleAppointments(page,date, appointmentCode,user,userTimeZone:string = "", isPublic: boolean = false): Observable<any> {        
        var FetchLeadUserInfo = page == -1 ? true : false;
        return this.http.get((isPublic ? 'publicflow/' : '')+'Appointment/RescheduleBookedAppointment?AppointmentCode=' + appointmentCode + '&UserTimeZoneId=' + userTimeZone + '&PageIndex=' + page + '&FetchLeadUserInfo=' + FetchLeadUserInfo + '&queryDate=' + date+ '&UserType='+ user,this.options)
            .map((response) => {
                var data = response.json().data;
                this.slotDataService.setAppointMentDetail(data);
                return data;
            })
    }

    /**
     * Function to cancel booked appointment
     * @param appointmentId : Cancel appointment by appointmentId
     */
    cancelAppointment(body, isPublic: boolean = false): Observable<any> {
        return this.http.post((isPublic ? 'publicflow/' : '')+'Appointment/CancelBookedAppointment',body,this.options)
            .map((response) => {
                return response.json();
            })
    }

    private timezonechange = new Subject<any>();

    timezoneChange(data: any) {
        this.timezonechange.next(data);
    }

    isTimezoneChange() {
        return this.timezonechange.asObservable();
    }
    getTimeZoneList(isPublic: boolean = false): Observable<any> {
        return this.http.get((isPublic ? 'publicflow/' : '') + 'Integration/GetTimeZoneList')
            .map((response) => {
                return response.json().data
            })
    }

    getTemplateSignatureByClientCode(type,clientCode, isPublic: boolean = false): Observable<any> {
        return this.http.get((isPublic ? 'publicflow/' : '')+`NotificationTemplate/GetTemplateSignatureByClientCode?SignatureType=${type}&ClientCode=${clientCode}`)
            .map((response) => {
                return response.json().data;
            })
    }

}





// WEBPACK FOOTER //
// ./src/app/slots/slots.service.ts